module.exports = __webpack_public_path__ + "img/jobs_sample_work_tab.222be887.svg";